var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1232,
    height: 138,
    viewBox: "0 0 1232 138",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3302_1407",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.581 69C141.581 106.931 111.704 138 70.6002 138C29.4961 138 0 107.312 0 69.3812V69C0 31.0691 29.8767 0 70.9808 0C112.085 0 141.581 30.6878 141.581 68.6188V69ZM110.943 69.3812V69C110.943 46.1271 94.1971 27.0663 70.6002 27.0663C47.0034 27.0663 30.6378 45.7459 30.6378 68.6188V69C30.6378 91.8729 47.384 110.934 70.9808 110.934C94.5777 110.934 110.943 92.2541 110.943 69.3812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.565 77.5773C281.565 117.986 258.92 137.809 223.144 137.809C187.368 137.809 165.484 117.796 165.484 78.5304V2.28729H194.79V77.768C194.79 99.4972 205.637 110.743 223.525 110.743C241.413 110.743 252.26 99.8784 252.26 78.721V2.28729H281.565V77.5773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.545 135.713H392.292L363.747 93.0166H340.721V135.713H311.415V2.28729H372.31C403.709 2.28729 422.549 18.8702 422.549 46.3177V46.6989C422.549 68.2376 410.941 81.7707 394.004 88.0608L426.545 135.713ZM392.863 48.2238V47.8425C392.863 35.2624 384.109 28.7818 369.837 28.7818H340.721V67.0939H370.407C384.68 67.0939 392.863 59.4696 392.863 48.2238Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.625 135.713H507.319V2.28729H536.625V135.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.123 135.713H674.007V48.605L636.519 105.597H635.757L598.649 49.1768V135.713H569.915V2.28729H601.504L636.519 58.7072L671.533 2.28729H703.123V135.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.548 48.7956C840.548 79.674 816.571 95.6851 786.694 95.6851H764.43V135.713H735.124V2.28729H789.549C821.328 2.28729 840.548 21.1575 840.548 48.4144V48.7956ZM810.862 49.3674V48.9862C810.862 35.8342 801.728 28.7818 787.075 28.7818H764.43V69.5718H787.646C802.299 69.5718 810.862 60.8039 810.862 49.3674Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.639 135.713H948.001L935.822 105.787H879.494L867.315 135.713H837.438L894.527 1.33425H921.55L978.639 135.713ZM925.356 79.8646L907.658 36.5967L889.96 79.8646H925.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.68 114.174C1093.98 128.851 1078.76 138 1053.07 138C1013.87 138 984.751 107.693 984.751 69.3812V69C984.751 31.0691 1013.3 0 1054.21 0C1079.33 0 1094.36 8.38673 1106.73 20.5856L1088.08 42.1243C1077.81 32.7845 1067.34 27.0663 1054.02 27.0663C1031.56 27.0663 1015.39 45.7459 1015.39 68.6188V69C1015.39 91.8729 1031.18 110.934 1054.02 110.934C1069.24 110.934 1078.57 104.834 1089.03 95.3039L1107.68 114.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232 29.3536H1191.47V135.713H1162.16V29.3536H1121.63V2.28729H1232V29.3536Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.581 69C141.581 106.931 111.704 138 70.6002 138C29.4961 138 0 107.312 0 69.3812V69C0 31.0691 29.8767 0 70.9808 0C112.085 0 141.581 30.6878 141.581 68.6188V69ZM110.943 69.3812V69C110.943 46.1271 94.1971 27.0663 70.6002 27.0663C47.0034 27.0663 30.6378 45.7459 30.6378 68.6188V69C30.6378 91.8729 47.384 110.934 70.9808 110.934C94.5777 110.934 110.943 92.2541 110.943 69.3812Z",
    stroke: "url(#paint0_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.565 77.5773C281.565 117.986 258.92 137.809 223.144 137.809C187.368 137.809 165.484 117.796 165.484 78.5304V2.28729H194.79V77.768C194.79 99.4972 205.637 110.743 223.525 110.743C241.413 110.743 252.26 99.8784 252.26 78.721V2.28729H281.565V77.5773Z",
    stroke: "url(#paint1_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.545 135.713H392.292L363.747 93.0166H340.721V135.713H311.415V2.28729H372.31C403.709 2.28729 422.549 18.8702 422.549 46.3177V46.6989C422.549 68.2376 410.941 81.7707 394.004 88.0608L426.545 135.713ZM392.863 48.2238V47.8425C392.863 35.2624 384.109 28.7818 369.837 28.7818H340.721V67.0939H370.407C384.68 67.0939 392.863 59.4696 392.863 48.2238Z",
    stroke: "url(#paint2_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M536.625 135.713H507.319V2.28729H536.625V135.713Z",
    stroke: "url(#paint3_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M703.123 135.713H674.007V48.605L636.519 105.597H635.757L598.649 49.1768V135.713H569.915V2.28729H601.504L636.519 58.7072L671.533 2.28729H703.123V135.713Z",
    stroke: "url(#paint4_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M840.548 48.7956C840.548 79.674 816.571 95.6851 786.694 95.6851H764.43V135.713H735.124V2.28729H789.549C821.328 2.28729 840.548 21.1575 840.548 48.4144V48.7956ZM810.862 49.3674V48.9862C810.862 35.8342 801.728 28.7818 787.075 28.7818H764.43V69.5718H787.646C802.299 69.5718 810.862 60.8039 810.862 49.3674Z",
    stroke: "url(#paint5_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M978.639 135.713H948.001L935.822 105.787H879.494L867.315 135.713H837.438L894.527 1.33425H921.55L978.639 135.713ZM925.356 79.8646L907.658 36.5967L889.96 79.8646H925.356Z",
    stroke: "url(#paint6_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.68 114.174C1093.98 128.851 1078.76 138 1053.07 138C1013.87 138 984.751 107.693 984.751 69.3812V69C984.751 31.0691 1013.3 0 1054.21 0C1079.33 0 1094.36 8.38673 1106.73 20.5856L1088.08 42.1243C1077.81 32.7845 1067.34 27.0663 1054.02 27.0663C1031.56 27.0663 1015.39 45.7459 1015.39 68.6188V69C1015.39 91.8729 1031.18 110.934 1054.02 110.934C1069.24 110.934 1078.57 104.834 1089.03 95.3039L1107.68 114.174Z",
    stroke: "url(#paint7_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1232 29.3536H1191.47V135.713H1162.16V29.3536H1121.63V2.28729H1232V29.3536Z",
    stroke: "url(#paint8_linear_3302_1407)",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_3302_1407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3302_1407",
    x1: 0,
    y1: 69,
    x2: 1232,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactGradient);
export default __webpack_public_path__ + "static/media/impact_gradient.d198ccecfb957fd24ad463c88fdf50a9.svg";
export { ForwardRef as ReactComponent };